const ViewChallengesBy = {
  TYPICAL: "typical",
  CATEGORY: "category",
  IMPORTANCE: "importance"
};

ViewChallengesBy.ALL = Object.values(ViewChallengesBy);

export default ViewChallengesBy;
